import { stringValidator } from './string';
export const bsonObjectIdValidator = ({ requiredError, formatError, }) => stringValidator({
    requiredError,
    formats: [
        {
            regex: /^[\dA-Fa-f]{24}$/,
            error: formatError,
        },
    ],
});
